import { gql } from "@apollo/client";

export const CREATE_APPROVAL_HIERARCHY = gql`
  mutation createapprovalHierarchy($input: createapprovalHierarchyInput) {
    createapprovalHierarchy(input: $input) {
      Id
      l2MinAmount
    }
  }
`;

export const APPROVAL_HIERARCHY_BY_ORGID = gql`
  query approvalHierarchyByOrg($orgId: Int!) {
    approvalHierarchyByOrg(orgId: $orgId) {
      Id
      orgId
      department
      role
      hierarchy
      employeeName
      createdOn
      taskType
     l2MinAmount
      deptDetails {
        deptId
        name
      }
      roleDetails {
        roleId
        name
      }
     
      l1approval
      l2approval
      l2MinAmount
      taskDetails {
        taskName
      }
    }
  }
`;

export const UPDATE_APPROVAL_HIERARCHY = gql`
  mutation updateApprovalHierarchy($input: updateapprovalHierarchyInput) {
    updateApprovalHierarchy(input: $input)
  }
`;

export const APPROVAL_HIERARCHY_BY_ID = gql`
  query getApprovalHierarchyById($Id: Int) {
    getApprovalHierarchyById(Id: $Id) {
      Id
          role
          l2MinAmount
      department
     
            taskType
   
      deptDetails {
        deptId
        name
      }
      roleDetails {
        roleId
        name
      }
      createdOn
     
      l1approval
      l2approval
    
      taskDetails {
        taskName
      }
    }
  }
`;

export const DELETE_APPROVAL_HIERARCHY = gql`
  mutation deleteApprovalHierarchy($Id: Int!) {
    deleteApprovalHierarchy(Id: $Id)
  }
`;

export const CREATE_RESIGNATION_APPROVAL = gql`
  mutation createapprovalResignation($input: createresignationApprovalInput) {
    createapprovalResignation(input: $input) {
      Id
    }
  }
`;

export const RESIGNATION_APPROVAL_BY_ORG = gql`
  query resinationApprovalByOrg($orgId: Int) {
    resinationApprovalByOrg(orgId: $orgId) {
      Id
      taskType
      department
      role
      orderBy
    }
  }
`;
